module.exports = __webpack_public_path__ + "static/GminaBedzino-9ad20445c84b67cb1530c4d1670692e7.svg";